import React, { useEffect } from "react";
import { Card } from "react-bootstrap";
import "./OrderSummary.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBagShopping } from "@fortawesome/free-solid-svg-icons";
import WhiteButton from "./../../common_components/common_button/WhiteButton";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getProduct } from "../../../features/admin/product/productdetails/Slice";
import { AllAppSetup } from "../../../features/admin/common/Slice";
import Cookies from "js-cookie";

const OrderSummary = ({
  productsdetails,
  all_app_setup,
  qty,
  triggerSubmit,
}) => {
  const navigate = useNavigate();

  const price = Number(productsdetails?.products?.price || 0);
  const shipping = Number(all_app_setup?.[0]?.shipping_charges || 0);

  const subtotal = price * qty;
  const grandTotal = subtotal + shipping;

  const handlePurchase = async () => {
    if (triggerSubmit) {
      await triggerSubmit();
    }

    const formData = Cookies.get("shippingData");

    if (!formData) {
      alert("Please fill shipping details");
      return;
    }

    const parsedData = JSON.parse(formData);

    const subtotal = price * qty;
    const grandTotal = subtotal + shipping;

    const orderData = {
      ...parsedData,
      quantity: qty,
      product_name: productsdetails?.products?.name,
      description: productsdetails?.products?.description,
      power: productsdetails?.products?.power,
      grand_total: grandTotal,
    };

    Cookies.set("orderData", JSON.stringify(orderData));

    navigate("/payment");
  };

  return (
    <div className="order-summary-wrapper">
      <Card className="order-summary shadow-sm">
        <h5 className="summary-heading">
          <FontAwesomeIcon className="shopping-icon" icon={faBagShopping} />
          Order Summary
        </h5>

        <div className="product-box">
          <div className="d-flex product-card align-items-center">
            <img src="/images/cart/productImg.png" alt="product" />
            <div className="product-details">
              <h6>{productsdetails?.products?.name}</h6>
              <p>{productsdetails?.products?.description}</p>
              <span>
                {productsdetails?.products?.power} -{" "}
                {productsdetails?.products?.productdetails?.quantity} Capsules
              </span>
            </div>
          </div>
        </div>
        <div className="price-row">
          <span>Subtotal</span>
          <span className="price-rs">₹ {subtotal}</span>
        </div>

        <div className="price-row">
          <span>Standard Shipping</span>
          <span className="price-rs">₹ {shipping}</span>
        </div>

        <div className="price-row">
          <span>Grand Total</span>
          <span className="price-rs">₹ {grandTotal}</span>
        </div>

        <div className="purchase-divider">
          <WhiteButton
            className="purchase-btn"
            title="Complete Purchase"
            bg="#010E1E"
            color="#F35F37"
            hoverBg="#010E1E"
            hoverColor="#F35F37"
            // onClick={() => navigate("/payment")}
            onClick={handlePurchase}
          />
        </div>

        <p className="trust-text ">
          {" "}
          <img src="/images/cart/100-percent.png" alt="not" /> Natural & Trusted
          Product
        </p>

        <p className="sub-trust-text ">
          Made with natural ingredients & trusted for quality and purity.
        </p>
      </Card>
    </div>
  );
};

export default OrderSummary;
